
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const Achievements = ({ achievementsSection }) => {
  if (!achievementsSection) return <></>;

  const leftPoints = achievementsSection.left_points || [];
  const rightSliders = achievementsSection.right_sliders || [];
  const achievementsHeading = achievementsSection.ach_achievements_heading || "Achievements";
  const achievementsSliders = achievementsSection.ach_achievements_sliders || [];

  return (
    <section className="p-2 p-md-3" style={{ background: "aliceblue" }}>
      <div className="container">
        <div className="row pb-5 d-flex align-items-center justify-content-center">
          <div className="col-md-4 col-12">
            <div className="sec-title text-center py-4">
              <h2>{achievementsSection.left_heading || 'TANGIBLE OUTCOMES'}</h2>
            </div>
            <ul className="vision-list">
              {leftPoints.map((p, i) => (
                <li key={i}>
                  <i className={`fa ${p.icon_class || 'fa-dot-circle-o'}`} /> {p.text}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-md-4 col-12">
            <div className="tournament-links text-center mb-3 mb-md-0">
              {/* Information Slider */}
              <div className="sec-title text-center py-0">
                <h2>{achievementsSection.right_heading || 'Information'}</h2>
              </div>

              <Swiper
                className="vertical-swiper info-swiper mb-0 mb-md-4"
                direction="vertical"
                loop={true}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                slidesPerView={1}
                spaceBetween={10}
                modules={[Autoplay]}
              >
                {rightSliders.map((sld, idx) => (
                  <SwiperSlide className="tournament-card" key={idx}>
                    <i className="fa fa-trophy" />
                    <a
                      href={`${process.env.REACT_APP_API_URL}/public${sld.pdf_url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {sld.title}
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
          <div className="col-md-4 col-12">
            <div className="tournament-links text-center">


              {/* Achievements Slider */}
              <div className="sec-title text-center py-0">
                <h2>{achievementsHeading}</h2>
              </div>

              <Swiper
                className="vertical-swiper ach-swiper"
                direction="vertical"
                loop={true}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                slidesPerView={1}
                spaceBetween={10}
                modules={[Autoplay]}
              >
                {achievementsSliders.map((sld, idx) => (
                  <SwiperSlide key={`ach-${idx}`} className="tournament-card">
                    <i className="fa fa-trophy" />
                    <a
                      href={`${process.env.REACT_APP_API_URL}/public${sld.pdf_url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {sld.title}
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;